import {Base} from "@/api/Base"

export class LeaveGet extends Base {
    path = "leave/get"
}